<template>
  <div class="big-screen-blog">
    <div class="b-left">
      <div class="b-content" v-html="feedText"></div>
      <div class="user">
        <img class="avatar" :src="avatar" /><span>{{ blog.screen_name }}</span>
      </div>
    </div>
    <div v-if="blog.feed_image_url" class="img" :style="imgStyle" />
  </div>
</template>

<script>
import defaultAvatar from "@assets/bigscreen/default_avatar.png";
import defaultImg from "@assets/bigscreen/default_img.png";
import { isImageLoaded, loadImage } from "./loadImage";

export default {
  name: "BigScreenBlog",
  props: {
    blog: { type: Object, default: () => ({}) },
  },
  computed: {
    imgStyle() {
      if (!this.isLoaded) {
        return {
          backgroundImage: `url(${defaultImg})`,
        };
      }
      if (this.blog.feed_image_url) {
        return {
          backgroundImage: `url(${this.blog.feed_image_url})`,
        };
      }
      return {};
    },
    feedText() {
      let text = this.blog.feed_text || "";
      text = text.replace(/#(.+?)#/g, function (s1) {
        return `<span style="color: #2f5277">${s1}</span>`;
      });
      return text;
    },
  },
  data() {
    return {
      isLoaded: false,
      avatar: this.blog.avatar_large || defaultAvatar,
    };
  },
  created() {
    this.toLoadImage(this.blog.feed_image_url);
  },
  watch: {
    "blog.feed_image_url": function (newVal) {
      this.toLoadImage(newVal);
    },
    "blog.avatar_large": function (newVal) {
      this.avatar = newVal || defaultAvatar;
    },
  },
  methods: {
    toLoadImage(src) {
      if (!src) {
        this.isLoaded = false;
        return;
      }
      if (isImageLoaded(src)) {
        this.isLoaded = true;
        return;
      }
      this.isLoaded = false;
      loadImage(src, (isLoaded) => {
        //博文没有变化时
        if (this.blog.feed_image_url === src) {
          this.isLoaded = isLoaded;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.big-screen-blog {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2.593vh;
  .b-left {
    margin-right: 2.222vh;
    text-align: left;
    .b-content {
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
      .topic {
        color: #2f5277;
      }
    }
    .user {
      display: flex;
      align-items: center;
      margin-top: 1.481vh;
      font-size: 2.963vh;
      font-family: PingFangSC-Regular;
      color: #464646;
      .avatar {
        height: 4.1666vh;
        width: 4.1666vh;
        margin-right: 1.666vh;
        border-radius: 50%;
      }
    }
  }
  .img {
    flex-shrink: 0;
    width: 17.685vh;
    height: 17.685vh;
    background-size: cover;
    background-position: top;
    border-radius: 0.925vh;
  }
  .load-img {
    position: absolute;
    width: 0;
    height: 0;
  }
}
</style>
